import { Component, Inject, OnInit, Optional, Input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// Ask this --> about material module on importing
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { SharedApiService } from '../../services/shared-api.service';
import lifeProductType from '../../life-config/productCodeConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import { DialogData } from '../../model/data.model';


@Component({
    selector: 'app-otp',
    templateUrl: './otp.component.html',
    styleUrls: ['./otp.component.css']
})

export class OTPComponent implements OnInit {

    OTPValidation: FormGroup;
    uuid: string;
    proposalId: string;

    apiUrl: object = apiUrlPoint.apiEndPoints;
    productType: object = lifeProductType.componentClassName;
    editModalConfData: object;
    inputValueFromCmp: number | string;
    calValFromCmp: object;
    annualIncomeInComma: any;
    numberInWords: any;
    annualIncomeData: any;
    sumAssuredValue: any;
    policyList: any = [];
    isLoaderActivated = false;
    isResendActive = false;
    proposalRes: any;
    isMobileNoActive = true;
    initializeCounter = 60;
    resendOTPtimer = true;
    isPaymentFailure = false;

    // Unable to add private class
    otpModalRes: any;
    destroySubject$: Subject<void> = new Subject();

    constructor(
        private dialogRef: MatDialogRef<OTPComponent>,
        private formbuild: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private apiService: ApiService,
        private sharedData: SharedApiService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {

        this.uuid = data['uuid'];
        this.proposalId = data['proposalId'];
        this.proposalRes = data['proposalRes'];
        this.isPaymentFailure = data['isPaymentFailure'];

        this.OTPValidation = this.formbuild.group({

            custOTP: ['',
                [Validators.required, Validators.minLength(1), Validators.maxLength(6), Validators.pattern(new RegExp('^[1-9][0-9]*$'))]],

        });

        this.apiService.getStatusEvent.subscribe(value => {

            if (value) {
                const errorStatusFromApi = value['status'];

                if (errorStatusFromApi === 400) {

                    this.isLoaderActivated = false;
                }
            }


        });


    }

    ngOnInit() {

        this.invokeQuoteOnInterval();

        setTimeout(() => {

            this.isResendActive = true;

        }, 60000);



    }


    verifyOTP(isValid: boolean, event) {

        if (isValid) {

            this.isLoaderActivated = true;


            const data = {
                otp_type: 1,
                otp_token: this.OTPValidation.get('custOTP').value
            };


            this.apiService.postWithData(

                this.apiUrl['apiV2LifeProposal'], this.proposalId, this.uuid, this.apiUrl['VerifyOTP'], data).subscribe(res => {

                    if (res) {

                        let url = this.apiUrl['apiV2LifeProposal'] + this.proposalId + '/' + this.apiUrl['initiatePayment'] + '/?uuid=' + this.uuid;

                        const InfoData = {
                            verified_otp_token: this.OTPValidation.get('custOTP').value,
                        };

                        if (this.isPaymentFailure) {
                            url = url + this.apiUrl['isRetry'];
                        }

                        this.apiService.postDataInfo(url, 'renewbuy-backend-header', InfoData).subscribe(otpres => {

                                if (otpres && otpres['response']) {

                                    this.isLoaderActivated = false;
                                    this.dialogRef.close({ event: 'close', data: otpres });

                                }

                            });

                    }


                });

        }


    }

    // initateOTP(valueObtained) {

    //     // this.router.navigate(['/life/payment-failure', this.proposalId, this.uuid]);
    //     // Add it into config

    //     const url = '/api/v2/life_v2/proposal/' + this.proposalId + '/' + 'send_otp/?uuid=' + this.uuid + '&via_email=' + valueObtained;

    //     const data = {
    //         otp_type: 1,
    //     };


    //     this.apiService.postDataInfo(url, 'renewbuy-backend-header',
    //         data).subscribe(otpRes => {

    //             if (otpRes) {

    //                 const otpres = otpRes;
    //             }


    //         });


    // }

    initateOTP() {

        // this.router.navigate(['/life/payment-failure', this.proposalId, this.uuid]);
       // Add it into config
        const data = {
            otp_type : 1,
        };

        this.apiService.postWithData(
            this.apiUrl['apiV2LifeProposal'], this.proposalId, this.uuid, this.apiUrl['sendOTP'], data).subscribe(otpRes => {

                if (otpRes) {

                    const otpres = otpRes;
                }


        });


    }

    /**
     * OTP - invoking via Mobile no
     */

    // OTPTriggerViaMobileNo() {
    //     this.isMobileNoActive = true;
    //     this.resendOTPtimer = true;
    //     this.initializeCounter = 60;
    //     this.initateOTP(0);
    // }

    /**
     * Email trigger
     */

    // OTPTriggerViaEmail() {

    //     this.isMobileNoActive = false;
    //     this.resendOTPtimer = true;
    //     this.initializeCounter = 60;
    //     this.initateOTP(1);



    // }

    counterInitilaize() {

        this.initializeCounter--

        if (this.initializeCounter === 0) {

            this.resendOTPtimer = false;



        }

        this.invokeQuoteOnInterval();

    };


    invokeQuoteOnInterval = async () => {

        // if (this.urlObtained['url'] === "/life/quotes/" + proposalId + '/' + uuid){
        setTimeout(() => {
            this.counterInitilaize();
        }, 1000);
        // }



    }



    cancelOTP() {
        this.dialogRef.close({ event: 'close' });
    }

}
